// Module
var code = "<h1 id=\"后浪\">后浪</h1> <blockquote> <p>恭喜你，到这里就看完了所有的条目。用你的毕生所学，去成为后浪吧！</p> </blockquote> <p><a href=\"https://www.bilibili.com/video/BV1FV411d7u7\">bilibili献给新一代的演讲《后浪》</a></p> ";
// Exports
module.exports = code;